import { useRef, useEffect } from 'react';

import lottieWeb from 'lottie-web';
import PropTypes from 'prop-types';

import { generateUrl } from '../SharedAsset/index';

const AnimatedLoader = ({ width, height, url }) => {
  const lottieContainerRef = useRef(null);
  useEffect(() => {
    lottieWeb.loadAnimation({
      container: lottieContainerRef.current,
      path: generateUrl(url),
      loop: true,
      autoPlay: true,
      name: 'lottie'
    });
  }, [url]);

  return (
    <div style={{ width: `${width}px`, height: `${height}px` }} ref={lottieContainerRef} />
  );
};

AnimatedLoader.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired
};

export default AnimatedLoader;
